// extracted by mini-css-extract-plugin
module.exports = {"title":"_2eGsB","footer":"xhsfu","readMore":"WJKh1"};